export enum MessageBusTransportType {
    SignalR = 'SignalR',
    Http = 'http'
}
